import AxiosService from '../AxiosService';

const getContainerDetails = async (containerId: string) => {
    const instance = AxiosService.createProductsAxiosInstance();
    const response = await instance.get(`/containers/${containerId}`);
    return response.data;
};

const getAllContainers = async (clientCode: string | undefined, perPage: number, currentPage: number) => {
    const instance = AxiosService.createProductsAxiosInstance();
    const response = await instance.get('/containers', {
        headers: {
            'X-Client-Code': clientCode,
            'per-page': perPage,
            'current-page': currentPage,
        },
    });
    return response.data;
};

const updateContainerStatus = async (containerId: string, status: string) => {
    const instance = AxiosService.createProductsAxiosInstance();
    const response = await instance.put(`/containers/${containerId}/status`, { status });
    return response.data;
};

const ContainerRequestPost = async (clientCode: string | undefined, containers) => {
    const instance = AxiosService.createProductsAxiosInstance();
    const response = await instance.post('/containers', {items:containers}, {
        headers: {
            'X-Client-Code': clientCode,
        },
    });

    return response.data;
};

const ContainerRequestStatusesGet = async (clientCode: string | undefined) => {
    const instance = AxiosService.createProductsAxiosInstance();
    const response = await instance.get('/containers/statuses', {
        headers: {
            'X-Client-Code': clientCode,
        },
    });
    return response.data;
}

const ContainerProductsGet = async (clientCode: string ) => {
    const instance = AxiosService.createProductsAxiosInstance();
    const response = await instance.get('/containers/products', {
        headers: {
            'X-Client-Code': clientCode,
        },
    }); 
    const products = Object.keys(response.data).reduce((acc, key) => {
        acc[key] = response.data[key].map((product: { description: string }) => {
                const categoryUnitNames = {
                    'Refrigerantes': 'Garrafas',
                    'Cervejas': 'Caixas',
                };
                const unitName  = categoryUnitNames[key];
                return {
                ...product,
                description: unitName === 'Caixas' ? (product.description)  : (product.description.replace(/\(CX\/\d+\)/g, '')),
                unitName,
            };
        });
        return acc;
    }, {});
    return products;
}

const ContainerGet = async (clientCode: string ) => {
    const instance = AxiosService.createProductsAxiosInstance();
    const response = await instance.get('/containers', {
        headers: {
            'X-Client-Code': clientCode,
        },
    });
    return response.data;
}


export default {
    ContainerRequestPost,
    ContainerGet,
    ContainerProductsGet,
    getContainerDetails,
    getAllContainers,
    updateContainerStatus,
    ContainerRequestStatusesGet
};